import { type ProductType as CommonProductType } from "@jeff/common-resources/src/offers/common";
import { ProductType } from "../lead-api";

export const FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_SUB_PRIME =
  "multi-product-offer-listing-sub-prime-flow";
export const FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_CREDIT_CARD =
  "multi-product-offer-listing-credit-card-flow";
export const FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_PERSONAL_LOAN =
  "multi-product-offer-listing-personal-loan-flow";
export const FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_OTHER =
  "multi-product-offer-listing-other-product-flow";
export const FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_INSURANCE =
  "multi-product-offer-listing-insurance-flow";

export const MULTI_PRODUCT_OL_FLOW_IDS = [
  FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_SUB_PRIME,
  FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_CREDIT_CARD,
  FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_PERSONAL_LOAN,
  FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_OTHER,
  FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_INSURANCE,
];

export const isMultiProductOlFlowId = (
  flowId: string | null | undefined,
): boolean => !!flowId && MULTI_PRODUCT_OL_FLOW_IDS.includes(flowId);

const productTypeToFlowIdMap: Record<string, string> = {
  [ProductType.SubPrime.toLowerCase()]:
    FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_SUB_PRIME,
  [ProductType.CreditCard.toLowerCase()]:
    FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_CREDIT_CARD,
  [ProductType.NearPrime.toLowerCase()]:
    FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_PERSONAL_LOAN,
  [ProductType.Other.toLowerCase()]: FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_OTHER,
  [ProductType.Insurance.toLowerCase()]:
    FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_INSURANCE,
};

export const getFlowIdFromProductType = (productType: CommonProductType) => {
  return productTypeToFlowIdMap[productType.toLowerCase()];
};

export const getMultiProductOlFallbackFlowId = (
  comaSeparatedProductTypes: string,
) => {
  const productTypes = comaSeparatedProductTypes.split(",");

  const firstProductType = productTypes[0];

  return (
    productTypeToFlowIdMap[firstProductType] ||
    FLOW_ID_MULTI_PRODUCT_OFFER_LISTING_SUB_PRIME
  );
};
